import { smoothAnchors } from '../components/smooth-anchors';

smoothAnchors();
